import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../base";
import { Job, Plan } from "../../domain/models/master-plan";
import { PlanningPortalRepository } from "../../repositories";
import { GetPlansByMasterPlanAndLocationIdRequest } from "../../domain/requests/planning-portal.request.ts/get-plans-by-master-plan-and-location-id.request";

@Injectable({providedIn: 'root'})
export class GetPlansByMasterPlanAndLocationIdUsecase implements UseCase<GetPlansByMasterPlanAndLocationIdRequest, Job[]> {

  constructor(private planningPortalRepository: PlanningPortalRepository) {
  }

  execute(params: GetPlansByMasterPlanAndLocationIdRequest): Observable<Job[]> {
    return this.planningPortalRepository.GetPlansByMasterPlanAndLocationId(params);
  }
}